import React, { JSX } from 'react';

interface RegisterAlertProps {
  title: string;
  message: string;
}

export const RegisterAlert: React.FC<RegisterAlertProps> = ({ title, message }): JSX.Element => (
  <div role="alert" className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
    <p className="font-semibold">{title}</p>
    <p className="mt-1">{message}</p>
  </div>
);
